import React from 'react';
import Navbar from './NavBar';
import AboutMe from './AboutMe';
import Services from './Services';
import ContactMe from './ContactMe';
import Footer from './Footer';
import styled from 'styled-components';
import Title from './Title';

const LandingPage = () => {
  return (
    <MainPageContainer>
      <Navbar />
      <Title />
      <AboutMe />
      <Services />
      <ContactMe />
      <Footer />
    </MainPageContainer>
  );
};

export default LandingPage;

const MainPageContainer = styled.div`
  max-width: 1500px;
  min-height: 100vh;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  margin: auto;
  display: flex;
  flex-direction: column;
`;
